import React from "react";
import "../Coming/coming.scss";
import MerchantLogo from "../../Assets/Images/logo.png";


const ChooseIssue = () => {
  return (
    <div className="resolve-main">
      <div className="resolve-banner">
        <div className="container">
          <div className="side-by-side">
            <h1>Resolve Center</h1>
            <div className="merchant-logo-dynamic">
              <img src={MerchantLogo} />
            </div>
          </div>
        </div>
      </div>

      <div className="resolve-desc">
        <div className="container">
          <p>
            Sit back and relax, we'll keep you posted on the email
            wiliom.smith@email.com.
          </p>
          <div id="accordion">
            <div className="card">
              <div className="card-header">
                Stolen from porch
                <span>
                  <i class="fas fa-caret-right"></i>
                </span>
              </div>
              <div className="collapse show"></div>
            </div>

            <div className="card">
              <div className="card-header">
                Item lost in transit
                <span>
                  <i class="fas fa-caret-right"></i>
                </span>
              </div>
              <div className="collapse show"></div>
            </div>

            <div className="card">
              <div className="card-header">
                Damaged item and shipping box.
                <span>
                  <i class="fas fa-caret-right"></i>
                </span>
              </div>
              <div className="collapse show"></div>
            </div>

            <div className="card">
              <div className="card-header">
                Defective item.
                <span>
                  <i class="fas fa-caret-right"></i>
                </span>
              </div>
              <div className="collapse show"></div>
            </div>

            <div className="card">
              <div className="card-header">
                Wrong item.
                <span>
                  <i class="fas fa-caret-right"></i>
                </span>
              </div>
              <div className="collapse show"></div>
            </div>

            <div className="card">
              <div
                className="card-header"
                data-toggle="modal"
                data-target="#myModal"
              >
                Damaged but shipping box is ok.
                <span>
                  <i class="fas fa-caret-right"></i>
                </span>
              </div>
              <div className="modal modal-common" id="myModal">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">item lost in transit</h5>
                      <span className="close" data-dismiss="modal">
                        <i class="fas fa-times"></i>
                      </span>
                    </div>

                    <div className="modal-body">
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipisicing
                        elit, sed do eiusmod Ut enim ad.
                      </p>
                      <button className="yellow-btn">Contact Merchant</button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="collapse show"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChooseIssue;
